import { Box, styled } from '@mui/material';

export const ItemContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  margin: theme.spacing(1),
  cursor: 'pointer',
  color: theme.palette.secondary.main,
  display: 'flex',
  flexBasis: 'calc(50% - 16px)',
  justifyContent: 'space-between',
  height: theme.spacing(7.25),
  borderRadius: theme.spacing(1),
  padding: theme.spacing(0.75, 3),
  alignItems: 'center',
  gap: theme.spacing(1),
  textAlign: 'center',

  '&:hover': { boxShadow: `0px 4px 12px ${theme.palette.primary.main}` },
}));
